import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AnnouncementBar() {
  const [text, setText] = useState("Free Singapore delivery with minimum spend ♡");
  useEffect(() => {
    api.get("/settings").then(({ data }) => data?.announcement_text && setText(data.announcement_text)).catch(() => {});
  }, []);
  return (
    <div data-testid="announcement-bar" className="w-full text-center text-[11px] tracking-editorial uppercase py-2.5"
         style={{ background: "#EBE5ED", color: "#4A464A" }}>
      {text}
    </div>
  );
}
